const initProductPageDrawer = () => {
  if (typeof window.customElements.get('icon-drawer-links') !== 'undefined') { return }
  window.customElements.define('icon-drawer-links', class IconDrawerLinks extends HTMLElement {
    constructor () {
      super()

      this.initLinks()
    }

    initLinks () {
      const toggles = this.querySelectorAll('[data-icon-drawers]')
      toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          this.toggleContent(toggle.getAttribute('data-icon-drawers'), toggles)
        })
      })
    }

    toggleContent (target, toggles) {
      const contents = this.querySelectorAll('[data-icon-drawers-content]')
      contents.forEach((content) => {
        content.classList.toggle('hide', (target !== content.getAttribute('data-icon-drawers-content')))
      })

      toggles.forEach((toggle) => {
        toggle.classList.toggle('active', toggle.getAttribute('data-icon-drawers') === target)
      })
    }
  })
}

function countrySelectorInit () {
  const navigation = document.querySelector('[data-mobile-navigation]')
  const content = document.querySelector('[data-country-selector-mobile-content]')
  const trigger = document.querySelector('[data-country-selector-mobile-trigger]')
  const close = document.querySelector('[data-country-selector-mobile-close]')

  trigger.addEventListener('click', handleCountrySelector)
  close.addEventListener('click', handleCountrySelector)

  function handleCountrySelector () {
    const state = content.dataset.countrySelectorMobileContent

    if (state === 'closed') {
      content.dataset.countrySelectorMobileContent = 'open'
      navigation.classList.add('hide')
      trigger.classList.add('hide')
    } else {
      content.dataset.countrySelectorMobileContent = 'closed'
      navigation.classList.remove('hide')
      trigger.classList.remove('hide')
    }
  }
}

function slideshowVideos () {
  const slideshowSections = document.querySelectorAll('slide-show')

  if (slideshowSections.length < 1) { return }

  slideshowSections.forEach((slideshowSection) => {
    const videos = slideshowSection.querySelectorAll('video')

    if (videos.length < 1) { return }

    const videoControls = slideshowSection.querySelector('[data-slideshow-video-controls]')
    const videoPlay = videoControls.querySelector('[data-slideshow-video-play]')
    const videoPause = videoControls.querySelector('[data-slideshow-video-pause]')

    videoPlay.addEventListener('click', () => {
      videos.forEach((video) => { video.play() })
      videoControls.classList.remove('slideshow__video-controls--paused')
      videoControls.classList.add('slideshow__video-controls--playing')
    })

    videoPause.addEventListener('click', () => {
      videos.forEach((video) => { video.pause() })
      videoControls.classList.remove('slideshow__video-controls--playing')
      videoControls.classList.add('slideshow__video-controls--paused')
    })
  })
}

document.addEventListener('DOMContentLoaded', () => {
  initProductPageDrawer()
  countrySelectorInit()
  slideshowVideos()
})

document.addEventListener('shopify:section:load', () => {
  countrySelectorInit()
  slideshowVideos()
})
